/* 🤖 this file was generated by svg-to-ts */
export const mgcIconArrowUpRegular: {
  name: 'arrow-up-regular';
  data: string;
} = {
  name: 'arrow-up-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.58 3.439c-.231.115-6.076 5.97-6.158 6.17-.077.184-.08.59-.007.765.079.189.291.417.481.517.215.114.659.121.864.014.077-.04 1.062-.993 2.19-2.119L11 6.74v6.703c0 7.536-.026 6.925.306 7.257.18.179.458.3.694.3.402 0 .827-.312.939-.69.054-.179.061-1.021.061-6.887V6.74l2.05 2.046c1.128 1.126 2.113 2.079 2.19 2.119.097.05.227.073.42.073.338 0 .541-.093.756-.344.161-.188.224-.366.224-.634 0-.434.155-.258-3.073-3.491-2.006-2.008-3.04-3.017-3.15-3.07-.221-.107-.62-.107-.837 0"/></svg>`
};
